import { BrowserRouter, Route, Switch } from "react-router-dom";

import AddPaper from "./components/papers/AddPaper";
import AddClassCard from "./components/classCards/AddClassCard";
import AllClasses from "./components/classes/Classes";
import AllPapers from "./components/papers/Papers";
import ClassCardBookingImport from "./components/classCards/ClassCardBookingImport";
import ClassCardBookings from "./components/classCards/ClassCardBookings";
import ClassCards from "./components/classCards/ClassCards";
import Coordinators from "./components/coordinators/Coordinators";
import Dashboard from "./components/dashboard/Dashboard";
import EditClass from "./components/classes/EditClass";
import EditDiscussion from "./components/papers/EditDiscussion";
import EditLiveSession from "./components/classes/EditLiveSession";
import EditPaper from "./components/papers/EditPaper";
import EditSession from "./components/classes/EditSession";
import LiveSessionBookingImport from "./components/classes/LiveSessionBookingImport";
import LiveSessionBookings from "./components/classes/LiveSessionBookings";
import SessionBookingImport from "./components/classes/SessionBookingImport";
import SessionBookings from "./components/classes/SessionBookings";
import LoadingScreen from "./components/layout/LoadingScreen";
import NotFound from "./components/layout/NotFound";
import OnlyLoggedOut from "./components/auth/OnlyLoggedOut";
import PaperBookingImport from "./components/papers/PaperBookingImport";
import PaperBookings from "./components/papers/PaperBookings";
// import PasswordUpdate from "./components/auth/PasswordUpdate";
import PreviewClass from "./components/classes/PreviewClass";
import PreviewPaper from "./components/papers/PreviewPaper";
import PrivateRoute from "./components/auth/PrivateRoute";
import Profile from "./components/profile/Profile";
import React from "react";
import ResetPassword from "./components/auth/ResetPassword";
import SignIn from "./components/auth/SignIn";
import SignUp from "./components/auth/SignUp";
import SingleClassCard from "./components/classCards/SingleClassCard";
import TeacherSingle from "./components/teachers/TeacherSingle";
import Teachers from "./components/teachers/Teachers";
import Transactions from "./components/transactions/Transactions";
import TxPreview from "./components/transactions/components/TxPreview";
import Faq from "./components/faq/Faq";
import Support from "./components/support/Support";
import TicketSingle from "./components/support/components/TicketSingle";
import Students from "./components/students/Students";
import SingleStudent from "./components/students/SingleStudent";
import ManualBooking from "./components/manualBooking/ManualBooking";
import Posts from "./components/posts/Posts";
import SinglePostPage from "./components/posts/SinglePostPage";

import { connect } from "react-redux";
import { isLoaded } from "react-redux-firebase";
import Verifications from "./components/verifications/Verifications";

function App(props) {
  const { profile } = props;
  if (isLoaded(profile)) {
    return (
      <BrowserRouter>
        <div className="App">
          <Switch>
            <PrivateRoute
              exact
              path="/"
              component={
                profile.token
                  ? profile.token.claims.role === "TEACHER" ||
                    profile.token.claims.role === "COMPANY_ADMIN"
                    ? Dashboard
                    : AllClasses
                  : AllClasses
              }
            />

            <PrivateRoute exact path="/transactions" component={Transactions} />
            <PrivateRoute
              exact
              path="/transactions/:id"
              component={TxPreview}
            />

            <PrivateRoute
              path="/cards/preview/:classCardId/bookings/import"
              component={ClassCardBookingImport}
            />
            <PrivateRoute
              path="/cards/preview/:classCardId/bookings"
              component={ClassCardBookings}
            />
            <PrivateRoute exact path="/cards/add" component={AddClassCard} />
            <PrivateRoute
              exact
              path="/cards/edit/:classCardId"
              component={SingleClassCard}
            />

            {/* <PrivateRoute exact path="/posts" component={Posts} />
            <PrivateRoute
              exact
              path="/posts/:postId"
              component={SinglePostPage}
            /> */}

            <PrivateRoute exact path="/faq" component={Faq} />

            <PrivateRoute exact path="/papers" component={AllPapers} />
            <PrivateRoute
              path="/papers/preview/:id/bookings/import"
              component={PaperBookingImport}
            />
            <PrivateRoute
              path="/papers/preview/:id/bookings"
              component={PaperBookings}
            />
            <PrivateRoute exact path="/papers/add" component={AddPaper} />
            <PrivateRoute
              path="/papers/edit/:examId/discussions/:discussionId"
              component={EditDiscussion}
            />
            <PrivateRoute path="/papers/edit/:id" component={EditPaper} />
            <PrivateRoute path="/papers/preview/:id" component={PreviewPaper} />

            <PrivateRoute exact path="/cards" component={ClassCards} />
            <PrivateRoute exact path="/profile" component={Profile} />
            <PrivateRoute exact path="/coordinators" component={Coordinators} />

            <PrivateRoute exact path="/support" component={Support} />
            <PrivateRoute exact path="/support/:id" component={TicketSingle} />

            <PrivateRoute exact path="/papers" component={AllPapers} />
            <PrivateRoute
              path="/papers/preview/:id/bookings/import"
              component={PaperBookingImport}
            />
            <PrivateRoute
              path="/papers/preview/:id/bookings"
              component={PaperBookings}
            />
            <PrivateRoute exact path="/papers/add" component={AddPaper} />
            <PrivateRoute
              path="/papers/edit/:examId/discussions/:discussionId"
              component={EditDiscussion}
            />
            <PrivateRoute path="/papers/edit/:id" component={EditPaper} />
            <PrivateRoute path="/papers/preview/:id" component={PreviewPaper} />

            <PrivateRoute exact path="/classes" component={AllClasses} />

            <PrivateRoute
              path="/classes/preview/:classId/live-sessions/:sessionId/bookings/import"
              component={LiveSessionBookingImport}
            />
            <PrivateRoute
              path="/classes/preview/:classId/live-sessions/:sessionId/bookings"
              component={LiveSessionBookings}
            />
            <PrivateRoute
              path="/classes/edit/:classId/live-sessions/:sessionId"
              component={EditLiveSession}
            />

            <PrivateRoute
              path="/classes/preview/:classId/sessions/:sessionId/bookings/import"
              component={SessionBookingImport}
            />
            <PrivateRoute
              path="/classes/preview/:classId/sessions/:sessionId/bookings"
              component={SessionBookings}
            />
            <PrivateRoute
              path="/classes/edit/:classId/sessions/:sessionId"
              component={EditSession}
            />
            <PrivateRoute path="/classes/edit/:id" component={EditClass} />

            <PrivateRoute
              path="/classes/preview/:id"
              component={PreviewClass}
            />

            <PrivateRoute exact path="/posts" component={Posts} />
            <PrivateRoute
              exact
              path="/posts/:postId"
              component={SinglePostPage}
            />

            <PrivateRoute path="/students" component={Students} />
            <PrivateRoute path="/student/:uid" component={SingleStudent} />

            <PrivateRoute path="/teachers/:uid" component={TeacherSingle} />
            <PrivateRoute path="/teachers" component={Teachers} />

            <PrivateRoute path="/manualBooking" component={ManualBooking} />

            <PrivateRoute path="/verifications" component={Verifications} />

            <OnlyLoggedOut path="/signin" component={SignIn} />
            <OnlyLoggedOut path="/password-reset" component={ResetPassword} />
            {/* <OnlyLoggedOut path="/password-update" component={PasswordUpdate} /> */}
            <OnlyLoggedOut path="/signup" component={SignUp} />
            <Route path="*" component={NotFound} />
          </Switch>
        </div>
      </BrowserRouter>
    );
  } else {
    return <LoadingScreen />;
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
  };
};

export default connect(mapStateToProps)(App);
